// extracted by mini-css-extract-plugin
export var aboveInput = "_o2-0";
export var actionButton = "_o2-5";
export var actionButtonContainer = "_o2-1";
export var actionIcon = "_o2-6";
export var aiInfoContainer = "_o2-2";
export var attachmentWrapper = "_o2-7";
export var bold = "_o2-3";
export var checkIcon = "_o2-8";
export var clickingRecipientBar = "_o2-11";
export var commentThreadSwitch = "_o2-a";
export var draftImage = "_o2-b";
export var draftImageContainer = "_o2-c";
export var draftImages = "_o2-e";
export var editButton = "_o2-g";
export var editor = "_o2-f";
export var editorContainer = "_o2-y";
export var editorErrorTooltipWrapper = "_o2-9";
export var headerDivider = "_o2-h";
export var icon = "_o2-i";
export var info = "_o2-j";
export var internal = "_o2-n";
export var internalDivider = "_o2-k";
export var internalMessage = "_o2-l";
export var messageInputCard = "_o2-m";
export var messageInputForm = "_o2-o";
export var messageInputFormInternal = "_o2-p";
export var options = "_o2-q";
export var publicMessageCustomer = "_o2-s";
export var publicMessageMerchant = "_o2-r";
export var removeImageButton = "_o2-d";
export var replyButtons = "_o2-t";
export var showSignatureButton = "_o2-u";
export var spinner = "_o2-v";
export var verticalButtonDivider = "_o2-4";
export var visibilitySelector = "_o2-w";
export var warning = "_o2-x";
export var wrappingText = "_o2-z";
export var writingInternalNoteTopBorder = "_o2-10";